import {
  ReactFlow,
  applyNodeChanges,
  applyEdgeChanges,
  addEdge,
  Controls,
  Background,
  BackgroundVariant,
  type ReactFlowProps,
  type NodeTypes,
  type EdgeTypes,
} from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import { cn } from 'utils/classnames'
import { GRAPH_BACKGROUND_COLOR, FIT_VIEW_MAX_ZOOM } from './constants'
import styles from './graph.module.scss'

export interface GraphProps extends ReactFlowProps {
  backgroundVariant?: BackgroundVariant
  containerClassName?: string
}

export function Graph({ containerClassName, nodeTypes, edgeTypes, className, ...props }: GraphProps) {
  return (
    <div className={cn(styles.container, containerClassName)}>
      <ReactFlow
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        fitView
        fitViewOptions={{ padding: 0.1, maxZoom: FIT_VIEW_MAX_ZOOM }}
        minZoom={0.2}
        maxZoom={2}
        attributionPosition="bottom-left"
        className={className}
        {...props}
      >
        <Controls />
        <Background bgColor={GRAPH_BACKGROUND_COLOR} />
      </ReactFlow>
    </div>
  )
}

export { applyNodeChanges, applyEdgeChanges, addEdge, BackgroundVariant }
export type { NodeTypes, EdgeTypes }
